<template>
    <div>
        <div v-if="!forgotPassword">
            <h1>Login</h1>
            <b-form @submit="onSubmit" class="login">
                <!-- email group -->
                <b-form-group
                    id="email-input-group"
                >
                    <label class="input-heading"><h5>Email:</h5></label>
                    <b-form-input
                        class="user-input"
                        id="email-input"
                        type="email"
                        v-model="form.email"
                        placeholder="Please enter your email"
                        required
                    ></b-form-input>
                </b-form-group>
                <!-- password group -->
                <b-form-group
                    id="password-input-group"
                >
                    <label class="input-heading"><h5>Password:</h5></label>
                    <b-form-input
                        class="user-input"
                        id="password-input"
                        type="password"
                        v-model="form.password"
                        placeholder="Please enter a password"
                        required
                    ></b-form-input>
                </b-form-group>
                <!-- submit buttons -->
                <b-button
                    type="submit"
                    variant="success"
                    class="submit-buttons">Login</b-button>
                <br><br>
                <h6 id="reset-password">
                    <a href="#" @click="resetPassword">
                        Forgot password?
                    </a>
                </h6>
                <h6 v-if="loginFailed" id="login-error">
                    {{errorMessage}}
                </h6>
            </b-form>
        </div>
        <div v-else>
            <h1>Reset Password</h1>
            <b-form @submit="onResetSubmit" class="login">
                <!-- email group -->
                <b-form-group
                    id="email-reset-group"
                >
                    <label class="input-heading"><h5>Email:</h5></label>
                    <b-form-input
                        class="user-input"
                        id="email-reset-input"
                        type="email"
                        v-model="resetEmail"
                        placeholder="Please enter your account's email"
                        required
                    ></b-form-input>
                </b-form-group>
                <!-- submit buttons -->
                <b-button
                    type="submit"
                    variant="success"
                    class="submit-buttons">Reset</b-button>
                <h6 v-if="passwordResetFailed" id="reset-error">
                    {{resetErrorMessage}}
                </h6>
            </b-form>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase';

export default {
    data() {
        return {
            formSubmitted: false,
            loginFailed: false,
            errorMessage: '',
            forgotPassword: false,
            resetSubmitted: false,
            resetEmail: '',
            passwordResetFailed: false,
            resetErrorMessage: '',
            form: {
                email: '',
                password: '',
            },
        };
    },
    methods: {
        onSubmit(event) {
            event.preventDefault();
            this.formSubmitted = true;
            console.log('this is the form information: ');
            console.log(this.form);
            this.login();
            this.formSubmitted = false;
        },
        login() {
            firebase
                .auth()
                .signInWithEmailAndPassword(this.form.email, this.form.password)
                .then(() => {
                    console.log('Successfully logged in');
                    this.$router.push('/profile');
                })
                .catch((error) => {
                    this.errorMessage = error.message;
                    this.loginFailed = true;
                    console.log(error.message);
                });
        },
        resetPassword() {
            this.forgotPassword = true;
        },
        onResetSubmit(event) {
            event.preventDefault();
            this.resetSubmitted = true;
            console.log('this is the reset email: ');
            console.log(this.resetEmail);
            this.sendResetRequest();
            this.resetSubmitted = false;
        },
        sendResetRequest() {
            firebase
                .auth()
                .sendPasswordResetEmail(this.resetEmail)
                .then(() => {
                    console.log('Successfully sent password reset');
                    this.$router.push('/user');
                })
                .catch((error) => {
                    this.resetErrorMessage = error.message;
                    this.passwordResetFailed = true;
                    console.log(error.message);
                });
        },
    },
};
</script>

<style scoped>

.login {
    width: 80%;
    margin: auto;
    background-color: white;
    padding: 2%;
}

.submit-buttons {
    margin: 10px;
}

h5 {
    font-weight: bold;
    color: black;
}

#login-error {
   font-weight: bold;
   color: red;
}

#reset-password {
    color: black;
    text-decoration: underline;
}

#reset-error {
    font-weight: bold;
    color: red;
}

</style>
